module.exports = __webpack_public_path__ + "img/extension.d89373bc.svg";